import{css}from'glamor';export var container=css({fontSize:'0.625rem'}).toString();